export default __webpack_public_path__ + "static/media/imc.89f744d6.png";